











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LeaveTeamModal_teamMember",
  "selections": [
    {
      "alias": "teamMemberId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "cce7bce8990ee2aaa84b9235c9ec0f86";

export default node;
